import { Link } from "react-router-dom";
import { SITE } from "../../../components/layout/site";
import { BRANCHES } from "../../../config/branches";

export function SocialLinks() {
	return (
		<div className="sp-socials">
			<a href={SITE.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
				<img src="/imgs/instagram.png" alt="Instagram" width={48} height={48} loading="lazy" />
			</a>
			<a href={SITE.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
				<img src="/imgs/facebook.png" alt="Facebook" width={48} height={48} loading="lazy" />
			</a>
			<a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp">
				<img src="/imgs/whatsapp.png" alt="WhatsApp" width={48} height={48} loading="lazy" />
			</a>
		</div>
	);
}

export default function SiteFooter() {
	return (
		<footer className="sp-footer">
			<div className="sp-container">
				<div className="sp-footer-grid">
					<div>
						<h3 className="sp-footer-title">NUESTROS HORARIOS</h3>
						{SITE.hours.map((h) => (
							<div key={h.days} className="sp-footer-spacer">
								<p className="sp-footer-accent">{h.days}</p>
								<p className="sp-footer-primary">{h.hours}</p>
							</div>
						))}
					</div>

					<div>
						<h3 className="sp-footer-title">CONTACTO</h3>
						<p className="sp-footer-accent">TELÉFONO</p>
						{SITE.phones.map((p) => (
							<a key={p.tel} className="sp-footer-primary" href={`tel:${p.tel}`}>
								{p.label}
							</a>
						))}
						<div className="sp-footer-spacer" />

						<p className="sp-footer-accent">SERVICIO TÉCNICO</p>
						<Link className="sp-footer-primary" to="/seguimiento">
							Rastrear mi servicio
						</Link>
						<div className="sp-footer-spacer" />

						<p className="sp-footer-accent">CORREO</p>
						<a className="sp-footer-primary" href={`mailto:${SITE.email}`}>
							{SITE.email}
						</a>
						<div className="sp-footer-spacer" />

						<p className="sp-footer-accent">{BRANCHES.length > 1 ? "SUCURSALES" : "SUCURSAL"}</p>
						{BRANCHES.map((b) => (
							<div key={b.key} className={BRANCHES.length > 1 ? "sp-footer-branch" : undefined}>
								{BRANCHES.length > 1 && <p className="sp-footer-branch-name">{b.city}</p>}
								{b.mapsUrl ? (
									<a className="sp-footer-primary" href={b.mapsUrl} target="_blank" rel="noreferrer">
										{b.address}
									</a>
								) : (
									<p className="sp-footer-primary">{b.address}</p>
								)}
							</div>
						))}
					</div>

					<div>
						<h3 className="sp-footer-title">SÍGUENOS</h3>
						<SocialLinks />
						<div className="sp-footer-spacer" />
						<img src={SITE.logo} alt="SpartechRD" className="sp-footer-logo" width={60} height={72} loading="lazy" />
					</div>
				</div>

				<p className="sp-footer-copy">
					© {new Date().getFullYear()} SpartechRD. Todos los derechos reservados.
				</p>
				<p className="sp-footer-copy sp-footer-credit">
					Powered by{" "}
					<a href="https://innoflextechnology.com" target="_blank" rel="noopener">
						<strong>Innoflex</strong>
					</a>
				</p>
			</div>
		</footer>
	);
}
